import { useCallback, useState } from "react";
import { getStudentById } from "../../../../services/studentService";
import { getAllFees } from "services/feeService";
import { getStudentAbsences } from "services/absenceService";

export default function useStudent() {
  const [student, setStudent] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [fees, setFees] = useState<any | null>(null);
  const [absences, setAbsences] = useState<any | null>(null);

  const fetchStudentById = useCallback(async (id: string) => {
    setLoading(true);
    try {
      const res = await getStudentById(id);
      setStudent(res.data);
      return true;
    } catch (err) {
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchFeesByStudentId = async (params: any) => {
    setLoading(true);
    try {
      const response = await getAllFees(params);
      console.log("response", response?.data?.data);
      setFees(response?.data?.data);
    } catch (err) {
      return false
    } finally {
      setLoading(false);
    }
  }


  const fetchAbsencesByStudentId = async (studentId: string) => {
    try {
      setLoading(true);
      const response = await getStudentAbsences(studentId ?? "");
      setAbsences(response.data || []);
    } catch (err: any) {
      return false;
    } finally {
      setLoading(false);
    }
  }


  return { student, loading, fetchStudentById, fetchFeesByStudentId, fees, absences, fetchAbsencesByStudentId };
}
